import { render, staticRenderFns } from "./BindParentBox.vue?vue&type=template&id=00a88444"
import script from "./BindParentBox.vue?vue&type=script&lang=js"
export * from "./BindParentBox.vue?vue&type=script&lang=js"
import style0 from "./BindParentBox.vue?vue&type=style&index=0&id=00a88444&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports